import { AccessTimeRounded } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { SignupProcessSteps } from './SignupProcessSteps';
export const SignupProcess = () => {
    return (React.createElement(Stack, { my: 4, alignItems: "center", maxWidth: "880px" },
        React.createElement(Typography, { textAlign: "center", color: "secondary", fontWeight: 600, fontSize: { xs: '1.2rem', md: '1.5rem' } }, "The Process"),
        React.createElement(Box, { sx: {
                p: 2,
                mt: 2,
                display: 'flex',
                borderRadius: '8px',
                width: 'fit-content',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'primary.light',
                height: { xs: 'auto', md: '48px' },
            } },
            React.createElement(Stack, { direction: "row", gap: 1, alignItems: "center", justifyContent: "center" },
                React.createElement(AccessTimeRounded, { color: "primary" }),
                React.createElement(Typography, { color: "primary", textAlign: "center", fontSize: "0.875rem", fontWeight: 500 }, "In the next five minutes you will be well on your way to an actionable funding strategy."))),
        React.createElement(SignupProcessSteps, null)));
};
